"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _classnames = _interopRequireDefault(require("classnames"));

var _opacity = _interopRequireDefault(require("../../theme/colors/opacity"));

var styles = function styles(theme) {
  return {
    bar: {},
    checked: {
      '&:active': {
        background: _opacity["default"].primary[800][14]
      },
      '&:hover': {
        background: _opacity["default"].primary[800][8]
      }
    },
    disabled: {
      '&$switchBase': {
        '&$checked': {
          '& + $bar': {
            backgroundColor: theme.palette.primary.main
          },
          color: theme.palette.primary.main
        },
        color: theme.palette.common.white
      }
    },
    rootDisabled: {
      opacity: '0.38'
    },
    switchBase: {
      '& + $bar': {
        opacity: 0.38
      },
      '&:active': {
        background: _opacity["default"].black[14]
      },
      '&:hover': {
        background: _opacity["default"].black[8]
      },
      color: theme.palette.common.white,
      height: '32px',
      left: '8px',
      width: '32px'
    }
  };
};

var Switch = function Switch(_ref) {
  var classes = _ref.classes,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["classes"]);
  return _react["default"].createElement(_Switch["default"], (0, _extends2["default"])({
    classes: {
      bar: classes.bar,
      checked: classes.checked,
      disabled: classes.disabled,
      root: (0, _classnames["default"])((0, _defineProperty2["default"])({}, classes.rootDisabled, rest.disabled)),
      switchBase: classes.switchBase
    }
  }, rest));
};

Switch.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes["default"].node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['primary', 'secondary', 'default']),

  /**
   * @ignore
   */
  defaultChecked: _propTypes["default"].bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes["default"].bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes["default"].node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes["default"].string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes["default"].object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes["default"].func,

  /**
   * The input component property `type`.
   */
  type: _propTypes["default"].string,

  /**
   * The value of the component.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool])
} : {};
Switch.defaultProps = {
  color: 'primary'
};

var _default = (0, _styles.withStyles)(styles)(Switch);

exports["default"] = _default;